module.exports = __webpack_public_path__ + "static/media/programming.8e638b7a.jpg";